<template>
  <el-dialog label-width="120px" label-position="top" :fullscreen="true" :visible="display"
             @closed="closed" @close="$emit('close', false)" @opened="opened" :destroy-on-close="true">
    <slot name="title">
      <h3 class="text-center">{{ $t('service.title.create') }}</h3>
      <hr>
    </slot>
    <el-row>
      <el-col :span="12" :offset="6">
        <el-form size="medium" ref="form">
          <el-form-item :label="$t('service.title.user')">
            <el-select ref="input" v-model="user" :placeholder="$t('text.click_to_select')" class="full-width">
              <el-option v-for="user in users" :key="user.id" :label="user.name" :value="user.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row slot="footer" class="dialog-footer">
      <el-col :span="12" :offset="6">
        <el-button @click="$emit('close', false)">{{ $t('button.close') }}</el-button>
        <el-button :disabled="!user" :loading="loading" type="primary" @click="submitForm">
          {{ $t('service.button.create') }}
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddServiceDialog',
  props: {
    display: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      users: [],
      user: null,
      loading: false
    }
  },
  methods: {
    async opened () {
      await this.fetchServiceProspects()
      this.$refs.input.focus()
    },
    closed () {
      this.user = null
      this.loading = false
    },
    async submitForm () {
      this.askQuestion(this.$t('service.confirm.create'), async () => {
        this.loading = true
        try {
          await this.withLoading(async () => {
            const data = await this.$serviceService.createService(this.user)
            this.notify(this.$t('service.message.created'), this.$t('status.success'))
            this.$emit('created', data)
            this.$emit('close')
          }, 'loading')
        } catch (error) {
          // Error is already handled by the global interceptor
          console.log('Component caught error in createService:', error)
        } finally {
          this.loading = false
        }
      })
    },
    async fetchServiceProspects () {
      this.users = await this.$serviceService.getNonServices()
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
